import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        color: theme.palette.secondary.main,
        padding: '0 20px 0 20px'
    },
    textIcon: {
        fontSize: 120,
        lineHeight: 1,
        marginTop: 30,
        marginBottom: theme.spacing(1),
        fontWeight: 'bold'
    },
    title: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
    },
    subTitle: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        color: theme.palette.text.secondary,
        fontSize: '1.2rem'
    },
    inputSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'center',
        '& .MuiTypography-root': {
            marginBottom: theme.spacing(4)
        }
    },
}));

export default useStyles;